// based on rc-pagination 1.17.8
export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/vc-pagination/index.js
// module id = 763
// module chunks = 16